import { Component, OnInit, Input } from '@angular/core'

import * as moment from 'moment'

@Component({
  selector: 'cm-schedule',
  templateUrl: './schedule.component.html',
  styleUrls: ['./schedule.component.css']
})
export class ScheduleComponent implements OnInit {

  @Input() datetimes: Date[]

  constructor() { }

  ngOnInit() {
  }

  public isDatetimePast(datetime: moment.Moment): boolean {
    return moment().isAfter(datetime)
  }
}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/shared/schedule/schedule.component.ts